var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drop',{directives:[{name:"show",rawName:"v-show",value:(_vm.$parent.$parent.editMode),expression:"$parent.$parent.editMode"}],ref:"dropper",staticClass:"sectionDrop",on:{"dragover":_vm.dragOver,"dragleave":_vm.dragOut,"dragend":_vm.dragOut,"drop":_vm.drop}})
}
var staticRenderFns = []

export { render, staticRenderFns }